import { identify, initialize, ready, update } from '../../actions/feature';
import ld from 'ldclient-js';

export const LAUNCHDARKLY_ALL = 'LAUNCHDARKLY_ALL';
export const LAUNCHDARKLY_ANONYMOUS = {
  anonymous: true,
  key: Math.random()
    .toString(36)
    .substring(7)
};
export const LAUNCHDARKLY_IDENTIFY = 'LAUNCHDARKLY_IDENTIFY';

const createDispatcher = (store, client) => {
  let isReady = false;

  const init = () => {
    if (isReady) return;
    store.dispatch(ready());
    store.dispatch(initialize(client.allFlags()));
    isReady = true;
  };

  client.on('ready', init);

  client.on('change', settings => store.dispatch(update(settings)));

  return (
    action = {},
    opts = {} // eslint-disable-line no-unused-vars
  ) => {
    const { type, payload = {} } = action || {};
    switch (type) {
      case LAUNCHDARKLY_IDENTIFY:
        client.identify(payload);
        store.dispatch(identify(payload));
        if (isReady) store.dispatch(initialize(client.allFlags()));
      default:
    }
  };
};

export const createClient = (id, options = {}) => {
  const user = {
    ...LAUNCHDARKLY_ANONYMOUS,
    ...options
  };

  return ld.initialize(id, user);
};

export default function createTracker(middleware, client) {
  return store => {
    const dispatch = createDispatcher(store, client);
    return next => action => {
      middleware(dispatch, store.getState(), action);
      return next(action);
    };
  };
}



// WEBPACK FOOTER //
// ./js/store/middleware/launchdarkly.js